import { Button } from "@freightsimple/ui-core/Controls/Button";
import { EmptyState } from "@freightsimple/ui-core/Display/EmptyState";
import { WarningCircleIcon } from "@phosphor-icons/react/WarningCircle";

/**
 * Shown when a view's data fails to load.
 *
 * Always offers the retry, because a carrier has no other way to reach this
 * data and a transient failure otherwise costs them a page reload.
 */
export function CarrierLoadFailed({
  what,
  onRetry,
}: {
  /** What we couldn't load, phrased to follow "We couldn't load" — e.g. "your shipments". */
  what: string;
  onRetry: () => void;
}) {
  return (
    <EmptyState
      icon={WarningCircleIcon}
      title={`We couldn't load ${what}`}
      description="Something went wrong on our side. Trying again usually sorts it."
      action={
        <Button primary onClick={onRetry}>
          Try again
        </Button>
      }
    />
  );
}
